import { useCallback, useState } from 'react';
import createUseContext from 'constate';

const useSearchProducts = () => {
  const [searchProductsConditions, setSearchProductsConditions] = useState({});
  const [searchProductsResults, setSearchProductsResults] = useState({});
  const [searchProductsPage, setSearchProductsPage] = useState(1);
  const [searchProductsHasMore, setSearchProductsHasMore] = useState(true);

  const set = useCallback((conditions, results, page, hasMore) => {
    setSearchProductsConditions(conditions);
    setSearchProductsResults(results);
    setSearchProductsPage(page);
    setSearchProductsHasMore(hasMore);
  }, []);

  return {
    searchProductsConditions,
    searchProductsResults,
    searchProductsPage,
    searchProductsHasMore,
    set,
  };
};

const [SearchProductsProvider, useSearchProductsContext] = createUseContext(useSearchProducts);

export {
  SearchProductsProvider,
  useSearchProductsContext,
};
